import React from 'react'

function EditRole() {
  return (
    <div>EditRole</div>
  )
}

export default EditRole